import { Box, Image, Typography } from "@outschool/backpack";
import { REFER_CREDIT_CENTS } from "@outschool/business-rules";
import { SignupModalQuery } from "@outschool/gql-frontend-generated";
import {
  Trans,
  renderCurrencyString,
  useTranslation,
} from "@outschool/localization";
import { useQuery } from "@outschool/ui-apollo";
import { SignupModalQuery as signupModalQuery } from "@outschool/ui-auth";
import { useConfetti } from "@outschool/ui-components-website";
import React, { useEffect } from "react";

import giftImage from "../../../../images/invite-page/ReferralsProgram_2023.png";
import SignupForm from "../../SignupForm";

type Props = {
  referrerSlugId: string;
};

export function ReferralSignupCard({ referrerSlugId }: Props) {
  const { t } = useTranslation(
    "client\\routes\\NewParentProfile\\ReferralSignupCard",
  );
  const { data: { referrer } = {}, loading } = useQuery<SignupModalQuery>(
    signupModalQuery,
    {
      variables: {
        referrerSlugId,
        skipReferrer: !referrerSlugId,
        skipLeader: true,
        skipActivity: true,
      },
      fetchPolicy: "no-cache",
      skip: false,
    },
  );

  const { confettiCannon, fireConfetti } = useConfetti({
    angle: 90,
    spread: 180,
    startVelocity: 25,
    elementCount: 50,
  });

  useEffect(() => {
    setTimeout(fireConfetti, 750);
  }, [fireConfetti]);

  if (loading || !referrer) {
    return null;
  }

  const onlyCreditAmount = renderCurrencyString({
    priceInCents: REFER_CREDIT_CENTS,
    showCurrencyCode: false,
  });

  const referrerName = referrer.leader?.approved
    ? referrer.leader.name
    : referrer.parent?.publicName;

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          mb: 16,
          pt: 16,
        }}
      >
        {confettiCannon}

        <Image src={giftImage} sx={{ height: 50, mb: 16 }} />

        <Trans t={t}>
          <Typography variant="h6" sx={{ textAlign: "center", mb: 4 }}>
            {{ referrerName }} gave you{" "}
            <Typography
              variant="h5"
              as="span"
              emphasized
              sx={{ textAlign: "center" }}
            >
              {{ onlyCreditAmount }}
            </Typography>{" "}
            in Outschool credit!
          </Typography>
        </Trans>

        <Trans t={t}>
          <Typography
            variant="body2"
            sx={{ color: "grey.600", textAlign: "center" }}
          >
            Sign up to claim your credits and join {{ referrerName }} on
            Outschool!
          </Typography>
        </Trans>
      </Box>
      <SignupForm
        promptLogin
        trackingUniqueId="signup-modal-signup-form-parent-profile"
        trackingParameters={{ signup_form_component: "parent-profile" }}
      />
    </>
  );
}
